export const branchFeaturesPath = '/branches/features';
export const singleBranchFeatureById = (id: number) => `${branchFeaturesPath}/${id}`;
